import { render, staticRenderFns } from "./CompareWidget.vue?vue&type=template&id=4b4dc475&scoped=true"
import script from "./CompareWidget.vue?vue&type=script&lang=js"
export * from "./CompareWidget.vue?vue&type=script&lang=js"
import style0 from "./CompareWidget.vue?vue&type=style&index=0&id=4b4dc475&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4dc475",
  null
  
)

export default component.exports